<template>
	<div>
		<!-- 面包屑导航区域 -->		<!-- 卡片视图区域 -->
		<el-card class="box-card">
			<!-- 搜索与添加区域 gutter设置两列之间的间距 -->
			<div style="margin-bottom: 20px;">
				<el-form ref="tripPageInfoReq" :model="tripPageInfoReq" label-width="70px" inline size="small">
					<el-form-item label="车锁编号:">
						<el-input :clearable=true v-model="tripPageInfoReq.bicycleNumber" placeholder="请输车锁编号" style="width: 120px;" />
					</el-form-item>
					<el-form-item v-if="this.user == 'admin'" label="运营商:" prop="distributorId">
						<el-select :clearable=true v-model="tripPageInfoReq.distributorId" :filterable=true
							placeholder="请选择" style="width: 120px;">
							<el-option v-for="item in distributorOptions" :key="item.key" :label="item.value"
								:value="item.key">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="手机号:">
						<el-input :clearable=true v-model="tripPageInfoReq.mobile" placeholder="请输手机号" style="width: 120px;" />
					</el-form-item>
					<el-form-item label="骑行状态:" prop="tripStatus">
						<el-select :clearable=true v-model="tripPageInfoReq.tripStatus" :filterable=true
							placeholder="请选择" style="width: 100px;">
							<el-option v-for="item in tripStatuOptions" :key="item.key" :label="item.value"
								:value="item.key">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="日期:">
						<el-date-picker v-model="dateRange" type="daterange" range-separator="-"
							start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd"
							value-format="yyyy-MM-dd" @change="handleDateChange">
						</el-date-picker>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="reGettripList()">查询</el-button>
					</el-form-item>
				</el-form>
			</div>
			<!-- 行程列表区域 -->
			<el-table :data="tripList" border stripe :header-cell-style="{ textAlign: 'center' }"
				:cell-style="{ textAlign: 'center' }">
				<el-table-column type="index" width="50"></el-table-column>
				<el-table-column label="车锁编号" prop="bicycleNumber" width = '130px'></el-table-column>
				<el-table-column v-if="this.user == 'admin'" label="运营商" prop="distributorId" width="120">
					<template slot-scope="scope">
						{{ getDistributorName(scope.row.distributorId) }}
					</template>
				</el-table-column>
				<el-table-column label="手机号" prop="mobile" width = '120px'></el-table-column>
				<el-table-column label="骑行状态" prop="tripStatus">
					<template slot-scope="scope">
						{{ scope.row.tripStatus == 1 ? '进行中' : (scope.row.tripStatus == 2 ? '已结束' : '未知') }}
					</template>
				</el-table-column>
				<el-table-column label="开始时间" prop="startTime" width="160"></el-table-column>
				<el-table-column label="结束时间" prop="endTime" width="160"></el-table-column>
				<el-table-column label="关锁时间" prop="lastLockTime" width="160"></el-table-column>
				<el-table-column label="骑行费用" prop="tripFee"></el-table-column>
				<el-table-column label="骑行时长(分钟)" prop="tripTimespan" ></el-table-column>
				<el-table-column label="支付类型" prop="payType">
					<template slot-scope="scope">
						{{ scope.row.payType == 0 ? '普通支付' : (scope.row.payType == 1 ? 'VIP支付' : '') }}
					</template>
				</el-table-column>
				<el-table-column label="结束类型" prop="isCoercion">
					<template slot-scope="scope">
						{{ scope.row.isCoercion == 1 ? '正常结束' : (scope.row.isCoercion == 2 ? '强制结束' : '') }}
					</template>
				</el-table-column>
				<el-table-column fixed="right" header-align="center" align="center" width="120" label="操作">
					<template slot-scope="scope">
						<el-button size="mini" type="danger" v-if="scope.row.tripStatus == 1"
							@click="coercionOverTrip(scope.row.id, scope.row.bicycleNumber)">强制结束行程</el-button>
					</template>
				</el-table-column>
			</el-table>
			<!-- 分页区域 -->
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
				:current-page="tripPageInfoReq.page" :page-sizes="[8, 15, 25, 50, 100]" :page-size="tripPageInfoReq.limit"
				layout="total, sizes, prev, pager, next, jumper" :total="total">
			</el-pagination>
		</el-card>
	</div>
</template>

<script>
import { getCurrentDistributorId } from '@/utils/distributor.js'

export default {
	data() {
		return {
			user: '',
			allottripInfo: {},
			distributorOptions: [],
			tripPageInfoReq: {
				page: 1,
				limit: 8,
				qrNumber: '',
				imei: '',
				distributorId: '',
				mobile: '',
				tripStatus: '',
				startDate: '',
				endDate: '',
				queryDistributorId: ''
			},
			tripList: [],
			total: 0,
			dateRange: [],
			tripStatuOptions: [{
				key: 1,
				value: '进行中'
			}, {
				key: 2,
				value: '已结束'
			}],
			positionModeOptions: [{
				key: 1,
				value: '基站定位'
			}, {
				key: 2,
				value: 'GPS定位'
			}, {
				key: 3,
				value: '手机定位'
			}],
		}
	},
	computed: {
		currentUser() {
			return this.user;
		}
	},
	created() {
		this.user = window.sessionStorage.getItem('user');
		this.inittripAllocation();
		this.tripPageInfoReq.queryDistributorId = getCurrentDistributorId()
		this.gettripList();
		// 监听运营商切换事件
		this.$root.$on('distributorChanged', this.handleDistributorChange)
	},
	beforeDestroy() {
		// 移除事件监听
		this.$root.$off('distributorChanged', this.handleDistributorChange)
	},
	methods: {
		getDistributorName(distributorId) {
			if (!distributorId) return '';
			const item = this.distributorOptions.find(o => o.key === distributorId);
			return item ? item.value : distributorId;
		},
		handleDistributorChange(distributorId) {
			this.tripPageInfoReq.queryDistributorId = distributorId || ''
			this.tripPageInfoReq.page = 1
			this.gettripList()
		},
		gettripList() {
			this.$http.post('/trip/manager/getTripPageInfo', this.tripPageInfoReq).then((res) => {
				if (res.data.code != 200) return this.$message.error(res.data.msg);
				this.tripList = res.data.data.list;
				this.total = res.data.data.total;
				console.log('this.tripList', this.tripList);
			});
		},
		reGettripList() {
			if (this.tripPageInfoReq.startDate == null || this.tripPageInfoReq.endDate == null) {
				this.tripPageInfoReq.startDate = ''
				this.tripPageInfoReq.endDate = ''
			}
			this.tripPageInfoReq.page = 1;
			this.gettripList();
		},
		handleDateChange(val) {
			if (val && val.length === 2) {
				this.tripPageInfoReq.startDate = val[0];
				this.tripPageInfoReq.endDate = val[1];
			} else {
				this.tripPageInfoReq.startDate = '';
				this.tripPageInfoReq.endDate = '';
			}
		},
		//监听pagesize变化
		handleSizeChange(pageSize) {
			this.tripPageInfoReq.limit = pageSize
			this.gettripList()
		},
		//监听页数变化
		handleCurrentChange(pageNum) {
			this.tripPageInfoReq.page = pageNum
			this.gettripList()
		},
		// 初始化车行程分配弹框
		inittripAllocation() {
			this.$http.get('/distributor/manager/getAllDistributorInfo').then((res) => {
				this.distributorOptions = [];
				if (res.data.code != 200) return this.$message.error(res.data.msg);
				let distributorInfoList = res.data.data;
				for (let index in distributorInfoList) {
					this.distributorOptions.push({ key: distributorInfoList[index].id, value: distributorInfoList[index].name });
				}
				console.log('this.distributorOptions：', this.distributorOptions);
			});
		},
		coercionOverTrip(id, bicycleNumber) {
			this.$confirm("确认强制结束 " + bicycleNumber + " 的行程吗？", {
				title: "提示",
				type: 'warning',
			}).then(resc => {
				this.$http.get('/trip/manager/coercionOverTrip/' + id).then((res) => {
					if (res.data.code != 200) return this.$message.error(res.data.msg);
					return this.$message.success(res.data.msg);
				});
			})

		}
	},
}
</script>

<style></style>